<template>
  <div class="section-container">
    <h1>Show Room Main Page</h1>
  </div>
</template>
